import styles from "./ArticleDek.module.scss";
import gql from "graphql-tag";
import { ArticleDekFragment } from "types/api";
import cx from "classnames";

const ArticleDek = ({ dek, primaryChannel }: ArticleDekFragment) => {
  if (!dek) return null;
  return (
    <p
      className={cx(
        styles.root,
        primaryChannel?.slug === "ideas" && styles.ideasRoot
      )}
      dangerouslySetInnerHTML={{ __html: dek }}
    />
  );
};

export default ArticleDek;

ArticleDek.fragment = gql`
  fragment articleDek on Article {
    dek
    primaryChannel {
      slug
    }
  }
`;
